import { render, staticRenderFns } from "./RushRace.vue?vue&type=template&id=31b472a7&scoped=true&"
import script from "./RushRace.vue?vue&type=script&lang=js&"
export * from "./RushRace.vue?vue&type=script&lang=js&"
import style0 from "./RushRace.vue?vue&type=style&index=0&id=31b472a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b472a7",
  null
  
)

export default component.exports